<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-row>
      <el-select v-model="cameraId" placeholder="选择监控" filterable @change="choseCamera">
        <el-option :label="item.name" :value="item.id" v-for="item in cameras" :key="item.id"></el-option>
      </el-select>      
      <el-select v-model="cameraPosId" placeholder="选择预置点" filterable>
        <el-option :label="item.name" :value="item.id" v-for="item in cameraPoses" :key="item.id"></el-option>
      </el-select>   
      <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col :span="6" v-for="item in tableData" :key="item.id">
        <div style="width: 100%;">
          <div style="width: 100%;text-align: center;"><img :src="item.netPath" style="height: 180px;margin: 0 auto;"/></div>
          <div style="width: 100%;text-align: center;">{{ item.name }}</div>
          <div style="width: 100%;text-align: center;">{{ formatDateSimple(item.addTime) }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import { formatDate } from '../../../util/date'
export default {
  data () {
    return {
      tableData: [],
      formLabelWidth: '120px',
      current: 1,
      pageSize: 16,
      total: 0,
      pages: 0,
      cameraId: 0,
      cameraPosId: 0,
      cameras: [{name:'全部', id:0}],
      cameraPoses: [{name:'全部', id:0}]
    }
  },
  created () {
    this.query()
    this.queryCamera()
  },
  methods: {
    queryCamera () {
      let that = this
      requestService.get(`/camera/listPage?current=1&pageSize=655350`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        if (!res.data.body.records||res.data.body.records.length==0) {
          return
        }
        that.cameras = that.cameras.concat(res.data.body.records)
      })
    },
    choseCamera (e) {
      this.cameraId = e
      this.queryCameraPos()
    },
    queryCameraPos () {
      let that = this
      that.cameraPoses = [{name:'全部', id:0}]
      requestService.get(`/cameraPos/listPage?current=1&pageSize=655350&cameraId=${that.cameraId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        if (!res.data.body.records||res.data.body.records.length==0) {
          return
        }
        that.cameraPoses = that.cameraPoses.concat(res.data.body.records)
      })
    },     
    query () {
      let that = this
      requestService.get(`/cameraPic/listPage?current=${that.current}&pageSize=${that.pageSize}&cameraId=${that.cameraId}&cameraPosId=${that.cameraPosId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    formatDateSimple (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/cameraPic/PicDataSet.vue